export default __webpack_public_path__ + "assets/images/allowingCorners-6889c98f7b4df51ca7557e289d85f7fb.svg";